import _ from "lodash";
import React from "react";
import { createUseStyles } from "react-jss";

import PropTypes from "prop-types";
import { Icon } from "@iconify/react";
import { cardStyles, variables } from "../../variables";

const styles = createUseStyles({
  EntityPreferences: {
    ...cardStyles.card,
    display: "grid",
    gridTemplateColumns: "repeat(1, 1fr)",
    justifyItems: "center",
    columnGap: variables.half_gap,
  },
  section: { ...cardStyles.card, padding: variables.half_gap, width: "100%" },
  sectionHeader: cardStyles.header,
  sectionBody: {
    ...cardStyles.body,
    display: "grid",
    gridGap: variables.half_gap,
  },
  checkboxes: { padding: variables.half_gap },
  checkIcon: {
    fontSize: "medium",
    background: "green",
    borderRadius: "50%",
    padding: `calc(${variables.normal_gap} / 6)`,
    color: "white",
  },
  notCheckIcon: {
    fontSize: "medium",
    background: "red",
    borderRadius: "50%",
    padding: `calc(${variables.normal_gap} / 6)`,
    color: "white",
  },
  category: {
    display: "grid",
    gridTemplateColumns: "max-content 1fr",
    gridGap: variables.half_gap,
    alignItems: "center",
  },
  [`@media ${variables.media.smallscreen}`]: {
    EntityPreferences: {
      gridTemplateColumns: "repeat(3, 1fr)",
    },
  },
});
const EntityPreferences = ({ entity }) => {
  const classes = styles();

  const licenses = _.get(entity, "license_type", []).map((l) => l[0]);
  const expertises = _.get(entity, "expertise_type", []);
  const tags = _.get(entity, "entity_type", []);

  return (
    <div className={classes.EntityPreferences}>
      <div className={classes.section}>
        <div className={classes.sectionHeader}>
          <label>License</label>
        </div>
        <div className={classes.sectionBody}>
          {[
            ["DOM", "Domestic License "],
            ["INBD", "International Inbound License"],
            ["OUTBD", "International Outbound License"],
          ].map(([key, label], idx) => (
            <div key={idx} className={classes.category}>
              {licenses.includes(key) ? (
                <Icon
                  icon="material-symbols:check"
                  // width="20"
                  // height="20"
                  className={classes.checkIcon}
                />
              ) : (
                <Icon
                  icon="ic:baseline-cancel"
                  // width="20"
                  // height="20"
                  className={classes.notCheckIcon}
                />
              )}
              <label>{label}</label>
            </div>
          ))}
        </div>
      </div>
      <div className={classes.section}>
        <div className={classes.sectionHeader}>
          <label>Expertise</label>
        </div>
        <div className={classes.sectionBody}>
          {[
            ["FIT", "Free Idependent"],
            ["GIT", "Group Inclusive Traveler"],
            ["MICE", "Meetings Incentives Conferencing Exhibitions"],
            ["CTM", "	Corporate Travel Management"],
          ].map(([key, label], idx) => (
            <div key={idx} className={classes.category}>
              {expertises.includes(key) ? (
                <Icon
                  icon="material-symbols:check"
                  // width="20"
                  // height="20"
                  className={classes.checkIcon}
                />
              ) : (
                <Icon
                  icon="ic:baseline-cancel"
                  // width="20"
                  // height="20"
                  className={classes.notCheckIcon}
                />
              )}
              <label>{label}</label>
            </div>
          ))}
        </div>
      </div>
      <div className={classes.section}>
        <div className={classes.sectionHeader}>
          <label>Tag</label>
        </div>
        <div className={classes.sectionBody}>
          {[
            ["DMC", "Destination Management Company"],
            ["TA", "Travel Agent"],
            ["TO", "Tour Operator"],
            ["OTA", "Online Travel Agent"],
            ["TMC", "	Travel Management Company"],
          ].map(([key, label], idx) => (
            <div key={idx} className={classes.category}>
              {tags.includes(key) ? (
                <Icon
                  icon="material-symbols:check"
                  className={classes.checkIcon}
                  // width="20"
                  // height="20"
                />
              ) : (
                <Icon
                  icon="ic:baseline-cancel"
                  // width="20"
                  // height="20"
                  className={classes.notCheckIcon}
                />
              )}
              <label>{label}</label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
EntityPreferences.propTypes = {
  entity: PropTypes.object.isRequired,
};

export default EntityPreferences;
